import {http} from '@/http'

export default {
  list() {
    return http.get('api/v1/business')
  },
  getAvailableDate() {
    return http.get('api/v1/business/available/date')
  },
  getLastClosedDate() {
    return http.get('api/v1/business/last/closed/date')
  },
  getStartDate() {
    return http.get('api/v1/business/startdate')
  },
  deleteData(params) {
    return http.delete('api/v1/business/data', {params})
  },
}
